import type { InvivoSceneManifestEntry } from "../types/invivo_scene";

export interface LegacyAssetRoots {
  assetBaseUrl: string;
  textureBaseUrl: string;
  sharedAssetBaseUrl: string;
}

export function normalizeAssetBaseUrl(root: string, appUrl: string): string {
  return new URL(`${root.replace(/\/+$/, "")}/`, appUrl).toString();
}

export function resolveLegacyAssetRoots({
  manifest,
  appUrl,
}: {
  manifest: InvivoSceneManifestEntry;
  appUrl: string;
}): LegacyAssetRoots {
  return {
    assetBaseUrl: normalizeAssetBaseUrl(manifest.assetRoot, appUrl),
    textureBaseUrl: normalizeAssetBaseUrl(manifest.textureRoot || manifest.assetRoot, appUrl),
    sharedAssetBaseUrl: normalizeAssetBaseUrl(manifest.sharedAssetRoot || "assets/shared", appUrl),
  };
}
